import {detectLocation} from "../api/detectLocation";
import {locationStore} from "../model/locationStore";
import {LocationType} from "../model/types";

const STORAGE_KEY = "cityCookieDaDataAdd";

class LocationService {
    initialize(location: LocationType) {
        const {actions} = locationStore.getState();

        actions.setLocation(location);
    }

    async detect() {
        if (localStorage.getItem(STORAGE_KEY) !== null) {
            return;
        }

        const {actions} = locationStore.getState();

        actions.setLoading(true);

        try {
            const response = await detectLocation();

            if (!response?.status) {
                return;
            }

            localStorage.setItem(STORAGE_KEY, "1");

            actions.setLocation(response.cityCookie);
        } finally {
            actions.setLoading(false);
        }
    }
}

export const locationService = new LocationService();
